"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchArray = void 0;
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
function batchArray(arr, batchSize) {
    (0, tiny_invariant_1.default)(batchSize > 0);
    var result = [];
    for (var i = 0; i < arr.length; i += batchSize) {
        result.push(arr.slice(i, i + batchSize));
    }
    return result;
}
exports.batchArray = batchArray;
